import { useEffect } from 'react';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import { initializeAnalytics } from '../utils/analytics-init';
import { analytics } from '../utils/analytics-proxy';

const { publicRuntimeConfig } = getConfig();

export function PostHogProvider({ children }: { children: React.ReactNode }) {
    const router = useRouter();

    useEffect(() => {
        // Initialize analytics with smart detection (NON-BLOCKING)
        const config = publicRuntimeConfig?.niioConfig;

        if (typeof window !== 'undefined' && config) {
            // Clear any existing blocked status to ensure fresh start
            sessionStorage.removeItem('posthog_blocked_status');
            localStorage.removeItem('posthog_blocked_status');
            (window as any).__posthog_errors = 0;
            (window as any).__ANALYTICS_BLOCKED__ = false;

            // Fire and forget - initialization is non-blocking
            initializeAnalytics(config);
        } else {
            console.warn('[PostHogProvider] Missing configuration');
        }
    }, []);

    // Track page views using proxy-aware analytics (NON-BLOCKING)
    useEffect(() => {
        const handleRouteChange = (url: string) => {
            if (typeof window !== 'undefined') {
                // Fire and forget - no await to avoid blocking navigation
                analytics.pageView(url);
            }
        };

        // Capture initial page view (NON-BLOCKING)
        if (typeof window !== 'undefined') {
            // Fire and forget - no await
            analytics.pageView(window.location.href);
        }

        router.events.on('routeChangeComplete', handleRouteChange);

        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);

    return <>{children}</>;
}
